const admin_es = require('./admin.json')
export default admin_es